import { KExpandable } from 'app/constants/GlobalTypes'
import { isArray } from 'lodash'

import { OverviewTableType } from './Table'

// map GraphQL response to Rest Invoice model
export const mapInvoice = (invoice: IInvoice): IInvoice => {
  return {
    amount: invoice.grossTotal,
    project_id: invoice.project?.id,
    rental_id: invoice.rental?.id,
    rental_code: invoice.rental?.rentalCode,
    invoice_date: invoice.financialInfo?.invoiceDate,
    ...invoice
  }
}

// build nested expandable structure for table
export const mapExpandableInvoiceGroups = (
  data: OverviewTableType[] = []
): KExpandable<OverviewTableType>[] => {
  if (!isArray(data)) return []

  return data.map((data) => mapExpandTypes(data))
}

// map record type to expandable type
const mapExpandTypes = (data: OverviewTableType): KExpandable<OverviewTableType> => {
  switch (data.__typename) {
    case 'InvoiceGroup':
      return {
        ...data,
        children: (data as IInvoiceGroup).invoices?.map(mapExpandTypes)
      }
    case 'Invoice':
      return {
        ...data,
        children: (data as IInvoice).invoiceItems?.map(mapExpandTypes)
      }
    default:
      return {
        ...data
      }
  }
}
